import { Reveal } from '../../hooks/useMotion';

const ICONS = {
  Residential: (
    <><path d="M6 24 18 14l12 10M10 21v17h16V21" /><rect x="28" y="8" width="14" height="30" /><path d="M32 13h2M36 13h2M32 19h2M36 19h2M32 25h2M36 25h2M16 38v-8h4v8" /></>
  ),
  Commercial: (
    <><rect x="14" y="6" width="20" height="34" /><rect x="5" y="18" width="9" height="22" /><rect x="34" y="16" width="9" height="24" /><path d="M19 12h10M19 18h10M19 24h10M19 30h10M21 40v-5h6v5" /></>
  ),
  Industrial: <><path d="M5 40V22l10 6v-6l10 6v-6l10 6V8h6v32Z" /><path d="M10 34h4M18 34h4M26 34h4" /></>,
  Healthcare: (
    <><rect x="8" y="14" width="32" height="26" /><rect x="18" y="5" width="12" height="12" rx="2" /><path d="M24 8v6M21 11h6M13 21h4M31 21h4M13 28h4M31 28h4M20 40v-8h8v8" /></>
  ),
  Infrastructure: <path d="M3 30h42M8 30V12M40 30V12M8 12c6 8 26 8 32 0M14 30v-8M20 30v-6M28 30v-6M34 30v-8M18 30l-6 12M30 30l6 12" />,
  'Education & Public': (
    <><path d="M5 18 24 8l19 10ZM8 18v20M40 18v20M4 40h40M14 22v14M20 22v14M28 22v14M34 22v14" /><circle cx="24" cy="14" r="1.5" /></>
  ),
};

export const Industries = ({ items }) => (
  <div className="ind" data-testid="industries">
    {items.map((name, i) => (
      <Reveal key={name} delay={i * 60}>
        <svg viewBox="0 0 48 48" aria-hidden="true">{ICONS[name]}</svg>
        <b>{name}</b>
      </Reveal>
    ))}
  </div>
);

export default Industries;
